import CourseComponent from "@components/CommonComponents/CourseComponent";
import EnrolledCourse from "@components/CommonComponents/CourseComponent/EnrolledCourse";
import CourseLoadingError from "./CourseLoadingError";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { EnrolledCourses } from "./EnrolledCoursesDataSchems";
import { getEnrolledCourse } from "@API/services/CourseCRUD/getEnrolledCourse";
import Courses from "@components/StudentDashBoardSubPages/Courses";
import {
  EnrolledCoursesList,
  SampledEnrolled,
} from "@components/CommonComponents/CourseComponent/SampleCourseData";
import { device } from "@styles/theme";
import Skeleton from "@components/CommonComponents/CourseComponent/Skeleton";
import EmptyComponent1 from "@components/CommonComponents/EmptyContanetComponents/EmptyComponent1";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectSettings } from "@app/redux/publicSelectors/settingsSelector";
import { getLanguageInfo } from "@lib/Enums/Language";
// styled-components----
const Container = styled.div``;
const LoaddingContainer = styled.div`
  width: 100%;
  padding-top: 3rem;
  font-size: 2rem;
  text-align: center;
`;
const Heading = styled.div`
  font-size: 1.375rem;
  line-height: 1.9375rem;
  color: ${(props) => props.theme.colors.gray[800]};
  font-weight: 700;
`;
const EnrolledCoursesContainer = styled.div`
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  row-gap: 1.25rem;
  @media ${device.tablet} {
    margin-top: 0.9375rem;
  }
`;
// ---------------------

function CourseInfo() {
  const [activeCourse, setActiveCourse] = useState<number>();
  const [Course, setCourse] = useState<EnrolledCoursesList>([]);
  const data = SampledEnrolled;
  const [CourseLoadingErrors, SetCourseLaodingError] = useState<boolean>(false);
  const [CoursesLoading, SetCourseLoading] = useState<boolean>(true);
  const { t } = useTranslation();
  const { language } = useSelector(selectSettings);

  const changeActive = (key: number) => {
    setActiveCourse(key);
  };
  async function getCourseData() {
    SetCourseLoading(true);
    const CourseData = await getEnrolledCourse();
    if (CourseData) {
      setCourse(CourseData);
    } else {
      SetCourseLoading(false);
      SetCourseLaodingError(true);
    }
    SetCourseLoading(false);
  }
  useEffect(() => {
    getCourseData();
  }, []);
  return (
    <Container>
      {CourseLoadingErrors && <CourseLoadingError />}
      <Heading>{t("sdashboard.courses.enrolled_heading")}</Heading>
      {CoursesLoading &&
        Array.from({ length: 5 }).map(() => {
          return (
            <EnrolledCoursesContainer>
              <Skeleton />
            </EnrolledCoursesContainer>
          );
        })}
      {!CourseLoadingErrors && !CoursesLoading && Course && (
        <EnrolledCoursesContainer>
          {Course.length ? (
            Course.map((e, index) => (
              <EnrolledCourse
                key={e.id}
                Course={Course[index]}
                setActive={changeActive}
                active={activeCourse === index}
                index={index}
              />
            ))
          ) : (
            <EmptyComponent1
              to={`/${getLanguageInfo(language).locale}/search`}
            />
          )}
        </EnrolledCoursesContainer>
      )}
    </Container>
  );
}

export default CourseInfo;
